import glam from 'glamorous';
import { Colors } from '../../const/Colors';
import { BrandonGrotesque } from '../../const/Fonts';

type TextProps = {
  centered?: boolean;
  size?: number;
};

export const Text = glam.p<TextProps>(p => ({
  textAlign: p.centered ? 'center' : 'left',
  color: Colors.logo.text,
  fontFamily: BrandonGrotesque.regularItalic,
  fontStyle: 'normal',
  fontWeight: 'normal',
  fontSize: `${1.4 * (p.size || 1)}rem`,
  marginTop: '0.2rem',
  marginBottom: 0,
}));

type WrapperProps = {
  centered: boolean;
  padding: boolean;
};

export const Wrapper = glam.div<WrapperProps>(p => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: p.centered ? 'center' : 'flex-start',
  padding: p.padding ? 20 : 0,
}));



// WEBPACK FOOTER //
// ./src/module/View/Common/component/Logo/Logo.s.ts